import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GeneratePatrimonioColumnsDefinition
 */

type Props = {
  onEditar: (idHabilidade: number) => void,
  onDeletar: (idHabilidade: number) => void,
};

export const GeneratePatrimonioColumnsDefinition = ({
  onEditar,
  onDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      width: 75,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "dataEntrega",
      filterable: false,
      headerName: "Data Entrega",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "dataDevolucao",
      filterable: false,
      headerName: "Data Devolução",
      sortable: false,
      width: 120,
      renderCell: (params) => (
        <div>{params.value && dayjs(params.value).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      field: "acoes",
      filterable: false,
      headerName: "Ações",
      sortable: false,
      valueGetter: (_, row) => row['idControlePatrimonio'] as number,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onEditar(value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onDeletar(value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}